import { Divider, Typography } from "@material-ui/core";
import React from "react";

export default function LabelledDivider({ label }) {
    return (
        <>
            <Divider />
            <Typography
                variant="body2"
                style= {{
                    textAlign: "center",
                    position: "relative",
                    top: -11,
                    marginLeft: -10,
                    paddingLeft: 5,
                    paddingRight: 5,
                    background: "white",
                    display: "inline-block",
                    left: "50%",
                    color: "#999"
                }}>
                {label}
            </Typography>
        </>
    );
}
